(() => {
  const selectedLengthByFormId = new Map();

  const parseNumber = (value) => {
    const normalized = `${value || ''}`.trim().replace(',', '.');
    if (!normalized) return null;

    const parsed = Number.parseFloat(normalized);
    return Number.isFinite(parsed) ? parsed : null;
  };

  const getKey = (container) => {
    return (
      container.dataset.productFormId ||
      container.closest('product-info')?.dataset?.section ||
      'klsh-hemming-default'
    );
  };

  const getLengthSelect = (container) => {
    return container.querySelector('select[data-klsh-hemming-length]');
  };

  const getRadios = (container) => {
    return Array.from(container.querySelectorAll('input[data-klsh-hemming-length]'));
  };

  const getSelectedLength = (container) => {
    const select = getLengthSelect(container);
    if (select) return select.value || '';

    return container.querySelector('input[data-klsh-hemming-length]:checked')?.value || '';
  };

  const valuesMatch = (firstValue, secondValue) => {
    const first = `${firstValue || ''}`.trim();
    const second = `${secondValue || ''}`.trim();

    if (!first || !second) return false;
    if (first === second) return true;

    const firstNumber = parseNumber(first);
    const secondNumber = parseNumber(second);

    return firstNumber !== null && secondNumber !== null && firstNumber === secondNumber;
  };

    const formatInches = (cmValue) => {
    const cmNumber = parseNumber(cmValue);
    if (cmNumber === null) return '';

    return (Math.round((cmNumber / 2.54) * 10) / 10).toFixed(1);
  };

  const updateLineItemProperties = (container, isDefault, selectedLength) => {
    const displayProperty = container.querySelector('[data-klsh-hemming-display-property]');
    const modeProperty = container.querySelector('[data-klsh-hemming-mode-property]');

    const selectedLengthText = `${selectedLength || ''}`.trim();
    const inches = formatInches(selectedLengthText);

    if (displayProperty && selectedLengthText && inches) {
      const label = isDefault ? 'Default length' : 'Free custom hem';

      displayProperty.name = `properties[${label}]`;
      displayProperty.value = `${inches} in / ${selectedLengthText} cm`;
    }

    if (modeProperty) {
      modeProperty.value = isDefault ? 'default' : 'custom';
    }
  };

    const updateLengthLabel = (container) => {
      const labelMode = container.querySelector('[data-klsh-hemming-label-mode]');
      const selectedLength = getSelectedLength(container);
      const defaultLength = `${container.dataset.defaultLength || ''}`.trim();

      const isDefault = valuesMatch(selectedLength, defaultLength);

      if (labelMode) {
        labelMode.textContent = isDefault ? '(Default)' : '(Custom)';
        labelMode.classList.toggle('is-default', isDefault);
        labelMode.classList.toggle('is-custom', !isDefault);
      }

      container.dataset.lengthMode = isDefault ? 'default' : 'custom';

      updateLineItemProperties(container, isDefault, selectedLength);
    };


  const rememberSelectedLength = (container) => {
    const selectedLength = getSelectedLength(container);
    if (!selectedLength) return;

    selectedLengthByFormId.set(getKey(container), selectedLength);
  };

  const findMatchingControl = (controls, requestedLength) => {
    const requested = `${requestedLength || ''}`.trim();
    const requestedNumber = parseNumber(requested);

    if (!requested) return null;

    return (
      controls.find((control) => control.value.trim() === requested) ||
      controls.find((control) => {
        const controlNumber = parseNumber(control.value);

        return (
          requestedNumber !== null &&
          controlNumber !== null &&
          controlNumber === requestedNumber
        );
      }) ||
      null
    );
  };

  const selectLengthForContainer = (
    container,
    requestedLength,
    allowFallback = false
  ) => {
    const select = getLengthSelect(container);
    const radios = getRadios(container);
    const controls = select ? Array.from(select.options) : radios;

    if (controls.length === 0) return '';

    const defaultLength = `${container.dataset.defaultLength || ''}`.trim();
    const requestedTarget = findMatchingControl(controls, requestedLength);

    const target =
      requestedTarget ||
      (allowFallback
        ? findMatchingControl(controls, defaultLength) ||
          (select ? select.selectedOptions[0] : radios.find((radio) => radio.checked)) ||
          controls[0] ||
          null
        : null);

    if (!target) return '';

    if (select) {
      select.value = target.value;
    } else {
      target.checked = true;
    }

    selectedLengthByFormId.set(
      getKey(container),
      target.value
    );

    updateLengthLabel(container);

    return target.value;
  };

const initContainer = (container, restorePrevious = true) => {
  if (!container) return;

  const select = getLengthSelect(container);
  const radios = getRadios(container);

  if (!select && radios.length === 0) return;

  const key = getKey(container);
  const preferredLength = restorePrevious
    ? selectedLengthByFormId.get(key)
    : '';

  if (container.dataset.klshHemmingInitialized !== 'true') {
    container.dataset.klshHemmingInitialized = 'true';

    container.addEventListener(
      'change',
      (event) => {
        if (!event.target.matches('[data-klsh-hemming-length]')) return;

        event.stopPropagation();
        rememberSelectedLength(container);
        updateLengthLabel(container);
      },
      true
    );

    container.addEventListener(
      'input',
      (event) => {
        if (!event.target.matches('[data-klsh-hemming-length]')) return;

        event.stopPropagation();
      },
      true
    );
  }

  container.klshHemming = {
    getSelectedLength: () => getSelectedLength(container),

    selectLength: (requestedLength) =>
      selectLengthForContainer(
        container,
        requestedLength,
        false
      ),

    select,
    radios,
  };

  selectLengthForContainer(
    container,
    preferredLength ||
      container.dataset.defaultLength ||
      getSelectedLength(container),
    true
  );

  updateLengthLabel(container);
};

  const init = (root = document, restorePrevious = true) => {
    root.querySelectorAll('[data-klsh-hemming]').forEach((container) => {
      initContainer(container, restorePrevious);
    });
  };

  const initAfterVariantChange = (event) => {
    const sectionId = event?.data?.sectionId;
    const root =
      (sectionId && document.querySelector(`product-info[data-section="${sectionId}"]`)) ||
      document;

    init(root, true);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document, false));
  } else {
    init(document, false);
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target, false);
  });

  document.addEventListener('product-info:loaded', (event) => {
    init(event.target, false);
  });

  if (
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined' &&
    PUB_SUB_EVENTS.variantChange
  ) {
    subscribe(PUB_SUB_EVENTS.variantChange, initAfterVariantChange);
  }
})();